import qs from 'qs';

export default function reducer(state = {
  hoAccounts: [],
  paging: {
    number: 1,
    size: 20,
  },
  hoAccount: {},
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_HO_ACCOUNTS_PENDING': {
      return {...state, fetching: true, fetched: false}
    }
    case 'GET_HO_ACCOUNTS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        hoAccounts: action.payLoad.data
      }
    }
    case 'GET_ADMIN_HO_ACCOUNTS_FULFILLED': {
        const lastPage = action.payLoad.links.last;
        let page = state.paging;
        if (lastPage) {
            page = qs.parse(lastPage.split('?')[1]).page;
        } else if (Object.keys(action.payLoad.links).length === 0) {
            page = {
                number: 1,
                size: 20,
            };
        }
        return {
            ...state,
            fetching: false,
            fetched: true,
            hoAccounts: action.payLoad.data,
            paging: page
        }
    }
    case 'GET_HO_ACCOUNTS_REJECTED': {
      return {
        ...state, errors: action.payLoad
      }
    }
    case 'GET_HO_ACCOUNT_PENDING': {
      return {...state, fetching: true, fetched: false}
    }
    case 'GET_HO_ACCOUNT_FETCHED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        hoAccount: action.payLoad.data,
      }
    }
    case 'GET_HO_ACCOUNT_REJECTED': {
      return {...state, fetching: false, fetched: false, hoAccount: {}}
    }
    default:
  }

  return {...state};
}



// WEBPACK FOOTER //
// ./src/reducers/hoAccountsReducer.js